import { getApp, getApps, initializeApp, type FirebaseApp } from 'firebase/app';
import { connectAuthEmulator, getAuth, type Auth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore, type Firestore } from 'firebase/firestore';

import { env } from '@/config/env';

const EMULATOR_HOST = '127.0.0.1';
const AUTH_EMULATOR_PORT = 9099;
const FIRESTORE_EMULATOR_PORT = 8080;

/**
 * Single Firebase initialisation for the whole application.
 *
 * `getApps()` is checked because Vite's hot reload re-evaluates modules; a
 * second `initializeApp` with the same name would throw.
 */
function createApp(): FirebaseApp {
  const existing = getApps();
  return existing.length > 0 ? getApp() : initializeApp(env.firebase);
}

export const firebaseApp: FirebaseApp = createApp();

function createAuth(): Auth {
  const auth = getAuth(firebaseApp);
  if (env.useEmulators) {
    connectAuthEmulator(auth, `http://${EMULATOR_HOST}:${AUTH_EMULATOR_PORT}`, {
      disableWarnings: true,
    });
  }
  return auth;
}

function createFirestore(): Firestore {
  const firestore = getFirestore(firebaseApp);
  if (env.useEmulators) {
    connectFirestoreEmulator(firestore, EMULATOR_HOST, FIRESTORE_EMULATOR_PORT);
  }
  return firestore;
}

export const firebaseAuth: Auth = createAuth();
export const firestore: Firestore = createFirestore();
